// extracted by mini-css-extract-plugin
module.exports = {"accent":"#1769e0"};